import React, {useState, useEffect} from 'react';

const QTY = ({
                 qty: initialQty = 1,  // Initial quantity provided by parent
                 setQty: externalSetQty, // Optional function provided by parent for setting quantity
                 minQty = 1,
                 maxQty = 10,
                 steps = 1,
                 isReadOnly = true,
                 pageLanguage,
                 NumberToPersianWord,
                 handleIncrement,
                 handleDecrement,
                 handleInputChange
             }) => {
    
    // Internal state for quantity
    const [internalQty, setInternalQty] = useState(initialQty);
    
    useEffect(() => {
        setInternalQty(initialQty);
    }, [initialQty]);
    
    // useEffect(() => {
    //     if (externalSetQty) {
    //         setInternalQty(initialQty);
    //     }
    // }, [initialQty, externalSetQty]);
    
    const internalHandleIncrement = () => {
        if (internalQty < maxQty) {
            const newQty = internalQty + steps;
            setInternalQty(newQty);
            if (externalSetQty) externalSetQty(newQty); // Call external function if provided
            if (handleIncrement) handleIncrement(steps); // Call external increment handler if provided
        }
    };
    
    const internalHandleDecrement = () => {
        if (internalQty > minQty) {
            const newQty = internalQty - steps;
            setInternalQty(newQty);
            if (externalSetQty) externalSetQty(newQty); // Call external function if provided
            if (handleDecrement) handleDecrement(parseFloat(0-steps)); // Call external decrement handler if provided
        }
    };
    
    const internalHandleInputChange = (e) => {
        console.log(`e`, e.target.value);
        let value = NumberToPersianWord.convertPeToEn(e.target.value);
        console.log(`value`, value);
        value = parseInt(value, 10);
        
        if (isNaN(value)) {
            return; // Ignore if the input is not a number
        }
        
        // Ensure value is within the allowed range
        if (value < minQty) {
            value = minQty;
        } else if (value > maxQty) {
            value = maxQty;
        }
        
        setInternalQty(value);
        if (externalSetQty) externalSetQty(value); // Call external function if provided
        if (handleInputChange) handleInputChange(value); // Call external input change handler if provided
    };
    
    const formatQuantity = () => {
        return pageLanguage === "fa"
            ? NumberToPersianWord.convertEnToPe(`${internalQty}`)
            : internalQty;
    };
    
    return (
        <div className="basket_item_qty_numbers">
            <button
                type="button"
                className="basket_qty_minus"
                onClick={internalHandleDecrement}
                disabled={internalQty <= minQty} // Disable button when qty is at min limit
            >
                <img
                    src={require('../Images/public/minus.svg').default}
                    alt=""
                    className="qty_math_icon img-fluid"
                />
            </button>
            <input
                type="text"
                className="basket_qty_num"
                value={formatQuantity()}
                onChange={isReadOnly ? null : internalHandleInputChange} // Conditionally allow changes
                readOnly={isReadOnly} // Set the input field as read-only based on the prop
            />
            <button
                type="button"
                className="basket_qty_plus"
                onClick={internalHandleIncrement}
                disabled={internalQty >= maxQty} // Disable button when qty is at max limit
            >
                <img
                    src={require('../Images/public/plus.svg').default}
                    alt=""
                    className="qty_math_icon img-fluid"
                />
            </button>
        </div>
    );
};

export default QTY;
